/* eslint-disable react/prop-types */
import { Link } from "react-router-dom";
import styles from "./index.module.css";
import { useRef } from "react";
import Flyout from "components/Flyout";
import Button from "components/Button";
import Text from "components/Text";
import Paper from "components/Paper";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as Logo } from "assets/images/logo.svg";
import { ReactComponent as Caption } from "assets/images/caption.svg";

const MenuFlyOut = ({ isOpen, onAttemptClose }) => {
  const createDiscountRef = useRef();
  // eslint-disable-next-line no-unused-vars
  return (
    <Flyout
      isOpen={isOpen}
      onAttemptClose={onAttemptClose}
      flyoutRef={createDiscountRef}
      helperClass={styles.notificationsFlyout}
    >
      <Paper className={styles.paper}>
        <div className={styles.navHeader}>
          <div className={styles.leftContainer}>
            <Link to="/">
              <Logo />
            </Link>
          </div>
          <div className={styles.rightContainer}>
            <Button
              variant="iconButton"
              onClick={onAttemptClose}
              className={styles.closeButton}
            >
              <CloseIcon />
            </Button>
          </div>
        </div>
        <Link to="/programare/step1" onClick={onAttemptClose}>
          <Text type={"h1"}>Fă o programare nouă</Text>
        </Link>
        <Link
          to={{ pathname: "https://goo.gl/maps/kiAUXitia5sxyfM88" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Text type={"h1"}>Locația Biroului de Asistență</Text>
        </Link>
        <Link to="/programare/operatingschedule" onClick={onAttemptClose}>
          <Text type={"h1"}>Program de funcționare</Text>
        </Link>
        <Link to="/programare/operatingregulations" onClick={onAttemptClose}>
          <Text type={"h1"}>Regulament de funcționare</Text>
        </Link>
        <hr className={styles.line} />
        <Link
          to={{ pathname: "https://ps4.ro/" }}
          target="_blank"
          onClick={onAttemptClose}
        >
          <Text type={"h1"}>{"Site principal PS4.ro —>"}</Text>
        </Link>
        <div className={styles.bottomContainer}>
          <Caption />
        </div>
      </Paper>
    </Flyout>
  );
};

export default MenuFlyOut;
